import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

//components
import Errors from "./Errors";
import { useLanguage, useTranslateFunction } from "lang/Translate";

// common components
import BallGridPulseLoader from "components/common/BallGridPulseLoader/BallGridPulseLoader";

//css
import "./scss/Form.scoped.scss";

//php Scripts
import api from "api/api";

const Signup = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [terms, setTerms] = useState(false);
	const [privacy, setPrivacy] = useState(false);
	const [requestInProgress, setRequestInProgress] = useState(false);

	const [credentials, setCredentials] = useState({
		email: null,
		password: null,
		password2: null,
		terms: false,
		privacy: false
	});

	const [errors, setErrors] = useState([]);
	const history = useHistory();
	const lang = useLanguage();
	const translate = useTranslateFunction("Signup");

	useEffect(() => {
		setCredentials({ email, password, password2, terms, privacy, lang });
	}, [email, password, password2, terms, privacy, lang]);

	const register = async e => {
		e.preventDefault();
		setRequestInProgress(true);

		try {
			const version = require("../../../package.json").version;
			await axios.post(`${api}/auth/signup?version=${version}`, credentials, {
				headers: { "content-type": "application/x-www-form-urlencoded" }
			});
			history.push(`/verification?type=pending&email=${email}`);
		} catch (e) {
			if (e.response.status === 409) {
				setErrors([
					{
						error: "Użytkownik o identycznym adresie e-mail już istnieje",
						errorEn: "User with same e-mail address already exists"
					}
				]);
				return;
			}

			if (e.response.status === 422) {
				setErrors([...e.response.data]);
				return;
			}

			console.error(e);
			const errorStr = `${e.response.status}: ${e.response.statusText}`;
			setErrors([
				{ error: errorStr, errorEn: errorStr },
				{ error: "Proszę spróbować ponownie później", errorEn: "Please try again later" }
			]);
		} finally {
			setRequestInProgress(false);
		}
	};

	if (requestInProgress) {
		return (
			<div className="main" style={{ display: "grid", placeContent: "center", height: "36rem" }}>
				<BallGridPulseLoader color="hsla(215, 50%, 23%, 1)" />
			</div>
		);
	}

	return (
		<div className="main">
			<h1>{translate("LABEL")}</h1>
			<div className="form_container">
				<form onSubmit={register}>
					<div className="input">
						<div className="icon">
							<i className="fas fa-envelope" aria-hidden="true" />
						</div>
						<input
							type="email"
							placeholder={translate("EMAIL")}
							value={email}
							onChange={e => setEmail(e.target.value)}
							autoComplete="email"
						/>
					</div>

					<div className="input">
						<div className="icon">
							<i className="fas fa-key" aria-hidden="true" />
						</div>
						<input
							type="password"
							placeholder={translate("PASSWORD")}
							value={password}
							onChange={e => setPassword(e.target.value)}
							autoComplete="new-password"
						/>
					</div>

					<div className="input">
						<div className="icon">
							<i className="fas fa-key" aria-hidden="true" />
						</div>
						<input
							type="password"
							placeholder={translate("REPEAT_PASSWORD")}
							value={password2}
							onChange={e => setPassword2(e.target.value)}
							autoComplete="new-password"
						/>
					</div>

					<div className="checkboxes">
						<div>
							<label>
								<input
									type="checkbox"
									value={credentials.privacy}
									onChange={e => setTerms(e.target.checked)}
								/>
								{translate("ACKNOWLEDGE")}{" "}
								<Link to="/terms" rel="nofollow noopener noreferrer" target="_blank">
									{translate("TERMS")}
								</Link>
							</label>
						</div>
						<div>
							<label>
								<input
									type="checkbox"
									value={credentials.privacy}
									onChange={e => setPrivacy(e.target.checked)}
								/>
								{translate("ACKNOWLEDGE")}{" "}
								<Link to="/privacy" rel="nofollow noopener noreferrer" target="_blank">
									{translate("PRIVACY")}
								</Link>
							</label>
						</div>
					</div>

					<Errors errors={errors} />

					<div className="button_container">
						<input type="submit" value={translate("REGISTER")} />
					</div>

					<Link to="/" className="block">
						<button className="register">{translate("LOGIN")}</button>
					</Link>
				</form>
			</div>
		</div>
	);
};

export default Signup;
